import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface RemoveMemberModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  memberName: string;
  onConfirm: () => void;
}

export function RemoveMemberModal({ open, onOpenChange, memberName, onConfirm }: RemoveMemberModalProps) {
  useLanguage();
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[420px] rounded-[18px] p-6">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center">
              <AlertCircle className="w-5 h-5 text-red-500" />
            </div>
            <DialogTitle className="text-lg font-semibold text-[#1E293B]">
              {translateInterfaceText("Remover Membro")}</DialogTitle>
          </div>
        </DialogHeader>

        <div className="py-4">
          <p className="text-[15px] text-[#475569] leading-relaxed">
            {translateInterfaceText("Tem certeza que deseja remover")}{" "}<span className="font-semibold">{memberName}</span>?
            <br />
            {translateInterfaceText("Ele perderá acesso imediatamente.")}</p>
        </div>

        <DialogFooter className="gap-3 sm:gap-3">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="h-11 rounded-[10px] border-[#E2E8F0] text-[#475569]"
          >
            {translateInterfaceText("Cancelar")}</Button>
          <Button
            onClick={handleConfirm}
            className="h-11 rounded-[10px] bg-red-500 hover:bg-red-600 text-white"
          >
            {translateInterfaceText("Remover")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
